/**
 * Webhook Triggers documentation page — inbound webhooks that start runs.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { webhookTriggersContent } from "@/constants/docs/webhook-triggers";

export const Route = createFileRoute("/docs/webhook-triggers")({
	component: WebhookTriggersPage,
});

function WebhookTriggersPage() {
	return <DocsPage title="Webhook Triggers" content={webhookTriggersContent} />;
}
